import type { PopupData } from 'webapp-types';

import BillingClientPacksUpdateComponent from 'webapp/components/billing/client-packs/update';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class BillingPopupClientPacksPurchaseComponent extends PopupInnerModalComponent<PopupData.Billing.QuantifiableAddonPurchase> {
	<template>
		<div class="title">
			<CommonUiIconComponent @name="Clients" @size="lg" />
			Additional account packs
		</div>
		<div class="content">
			<BillingClientPacksUpdateComponent
				@onClose={{this.close}}
				@scheduleReposition={{this.scheduleReposition}}
				@origin={{this.popupData.origin}}
			/>
		</div>
	</template>
}
